export default [
  {
    color: "#2eaf9f",
    label: "ThemeColor",
  },
  {
    color: "#e0f3f1",
    label: "ThemeColor-light",
  },
  {
    color: "#000000",
    label: "Black",
  },
  {
    color: "hsl(0, 0%, 30%)",
    label: "Dim grey",
  },
  {
    color: "hsl(0, 0%, 60%)",
    label: "Grey",
  },
  {
    color: "hsl(0, 0%, 90%)",
    label: "Light grey",
  },
  {
    color: "hsl(0, 0%, 100%)",
    label: "White",
    hasBorder: true,
  },
  {
    color: "hsl(0, 75%, 60%)",
    label: "Red",
  },
  {
    color: "hsl(30, 75%, 60%)",
    label: "Orange",
  },
  {
    color: "hsl(60, 75%, 60%)",
    label: "Yellow",
  },
  {
    color: "hsl(90, 75%, 60%)",
    label: "Light green",
  },
  {
    color: "hsl(120, 75%, 60%)",
    label: "Green",
  },
  {
    color: "hsl(120, 75%, 60%)",
    label: "Green",
  },
  {
    color: "#CD5C5C",
    label: "IndianRed",
  },
  {
    color: "#F08080",
    label: "LightCoral",
  },
  {
    color: "#FA8072",
    label: "Salmon",
  },
  {
    color: "#DC143C",
    label: "Crimson",
  },
  {
    color: "#B22222",
    label: "FireBrick",
  },
  {
    color: "#8B0000",
    label: "DarkRed",
  },
  {
    color: "#FFA07A",
    label: "LightSalmon",
  },
  {
    color: "#FF7F50",
    label: "Coral",
  },
  {
    color: "#FF6347",
    label: "Tomato",
  },
  {
    color: "#BDB76B",
    label: "DarkKhaki",
  },
  {
    color: "#191970",
    label: "MidnightBlue",
  },
  {
    color: "#000080",
    label: "Navy",
  },
  {
    color: "#00008B",
    label: "DarkBlue",
  },
  {
    color: "#800000",
    label: "Maroon",
  },
  {
    color: "#ededed",
    label: "light-bg",
  },
  {
    color: "#28b12b",
    label: "result-success",
  },
  {
    color: "#f21515",
    label: "result-failur",
  },
];
